/* eslint-disable */
// @flow

export function promiseTimeout(timeout: number = 0): Promise<void> {
    return new Promise((resolve, reject) => {
        setTimeout(resolve, timeout);
    })
}
